var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableProfitGreenArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14C9.779 14 9.559 13.928 9.375 13.781L5.074 10.34L1.707 13.707C1.316 14.098 0.683998 14.098 0.292998 13.707C-0.0980018 13.316 -0.0980018 12.684 0.292998 12.293L4.293 8.29301C4.654 7.93201 5.228 7.90101 5.625 8.21901L9.926 11.66L19.293 2.29301C19.684 1.90201 20.316 1.90201 20.707 2.29301C21.098 2.68401 21.098 3.31601 20.707 3.70701L10.707 13.707C10.513 13.901 10.257 14 10 14Z",
    fill: "#30A590"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.176 1.417C22.203 1.252 22.15 1.085 22.031 0.968001C21.914 0.850001 21.747 0.797001 21.583 0.824001L18.992 1.25C18.801 1.282 18.643 1.417 18.585 1.602C18.525 1.786 18.574 1.988 18.711 2.125L20.875 4.289C21.012 4.426 21.214 4.475 21.398 4.415C21.582 4.355 21.717 4.198 21.749 4.007L22.176 1.417Z",
    fill: "#30A590"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableProfitGreenArrowIcon);
export default __webpack_public_path__ + "static/media/table_profit_green_arrow_icon.8c68bc42.svg";
export { ForwardRef as ReactComponent };